import { Injectable, NgZone } from '@angular/core';

import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Http } from '@angular/http';
import { ToastController } from 'ionic-angular';

import { CommonData } from '../../providers/common-data';
import { UserData } from '../../providers/user-data';





@Injectable()
export class UEModel {

  public srcPhotoAuto : string = "";
  public sDateTimeAuto : string = "";
  public srcPhotoAuto2 : string = "";
  public sDateTimeAuto2 : string = "";
  public srcPhotoAuto3 : string = "";
  public sDateTimeAuto3 : string = "";
  public srcPhotoAuto4 : string = "";
  public sDateTimeAuto4 : string = "";
  public srcPhotoBeweis : string = "";
  public sDateTimeBeweis : string = "";
  public debug : string = "";
  public sQRCode = "";
  public iUploadCounter: number = 0;
  public iGrundid: number = 0;
  public fkkontrolle: number = 0;
  public autonummer: string = "";
  public kontrollkommentar: string = "";
  public checkresultdata: any;
  constructor(public events: Events, public storage: Storage, public http: Http, public toastCtrl: ToastController, public common: CommonData, public userData: UserData, public zone: NgZone) {


  }

  public clear(){
    this.srcPhotoAuto = "";
    this.sDateTimeAuto = "";
    this.srcPhotoAuto2 = "";
    this.sDateTimeAuto2 = "";
    this.srcPhotoAuto3 = "";
    this.sDateTimeAuto3 = "";
    this.srcPhotoAuto4 = "";
    this.sDateTimeAuto4 = "";
    this.srcPhotoBeweis = "";
    this.sDateTimeBeweis = "";
    this.sQRCode = "";
    this.autonummer = "";
    this.iUploadCounter = 0;
    this.iGrundid = 0;    
    this.fkkontrolle = 0;
    this.kontrollkommentar = "";
    this.checkresultdata = "";
  }



}



// WEBPACK FOOTER //
// ./src/pages/ue/ue-model.ts